













import { Component, Prop, Watch } from 'vue-property-decorator';
  import PickerBase from './base';
  import query from '@/components/query/query-constructor';
  import UrlMixin from '@/components/query/url-mixin';
  import { mixins } from 'vue-class-component';

  @Component
  export default class StatusPicker extends mixins(PickerBase, PickerBase,UrlMixin) {
    @Prop({ default: false })
    silent: boolean;

    get value(){
      if(this.isDashbord){
        return this.$store.state.dashboard.queryTemporary.status || this.defaultValue
      }else{
        return this.$store.state.table.query[this.tableQueryParam] || this.defaultValue
      }
    }

    get defaultValue(){
      return this.isPostback ? 'all' : 'active';
    }

    get icon() {
       return this.items.find((item) => item.value === this.value)?.icon;
    }

    get isPostback(){
      return this.routeName === 'app.postbacks'
    }

    get items(){
      if(this.isPostback){
        return [
          {
            value: 'all',
            text: this.t('All'),
            icon: 'fas fa-list'
          },
          {
            value: '1',
            text: this.t('sent'),
            icon: 'fas fa-check'
          },
          {
            value: '0',
            text: this.t('failed'),
            icon: 'fas fa-xmark'
          },
        ]
      }else{
        return [
          {
            value: 'active',
            text: this.t('____x.active'),
            icon: 'fas fa-play'
          },
          {
            value: 'archived',
            text: this.t('Archived'),
            icon: 'fas fa-archive'
          },
          {
            value: 'withTraffic',
            text: this.t('With Traffic'),
            icon: 'fas fa-heartbeat'
          },
          {
            value: 'all',
            text: this.t('All'),
            icon: 'fas fa-list'
          },
        ]
      }
    }

    get tableQueryParam(){
      return this.isPostback ? 'postbackStatus' : 'status'
    }

    mounted() {
      this.applyDataFromUrl()
    }

    applyDataFromUrl() {
      if(this.isDashbord){
        const { status } = query.decode(this.$route.params.data);
        this.$store.commit('dashboardQueryTemporary', {
          name: 'status',
          value: status || this.defaultValue
        });
        this.$store.commit('dashboardQuery', {
          name: 'status',
          value: status || this.defaultValue
        });
      }else {
        const params = query.decode(this.$route.params.data);
        this.$store.commit('tableQuery', {
          name: this.tableQueryParam,
          value: params[this.tableQueryParam] || this.defaultValue
        });
      }
    }

    statusChanged(value){
      if(this.isDashbord){
        this.$store.commit('dashboardQueryTemporary', {
          name: 'status',
          value: value
        });
      }else {
        this.$store.commit('tableQuery', {
          name: this.tableQueryParam,
          value: value
        });
        this.pushURL();
        this.bus.emit('reset-offset');
      }
    }
  }
